import { render, staticRenderFns } from "./TaxCalculation.vue?vue&type=template&id=6ea4f2fc&scoped=true"
import script from "./TaxCalculation.vue?vue&type=script&lang=js"
export * from "./TaxCalculation.vue?vue&type=script&lang=js"
import style0 from "./TaxCalculation.vue?vue&type=style&index=0&id=6ea4f2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea4f2fc",
  null
  
)

export default component.exports